export default __webpack_public_path__ + "static/media/work.b429c810.jpg";